const ROUTES = 'CS/ROUTES';
/* eslint-disable import/prefer-default-export */
export const ROUTES_REINITIALISE = `${ROUTES}_REINITIALISE`;
